import React from 'react';
import TranslationsContext from './translations-context';

export function mapTranslationsProps(config = {}, translations = {}, allowUndefined = false) {
    const props = {};
    for (let key in config) {
        if (config.hasOwnProperty(key)) {
            if (!allowUndefined) {
                props[config[key]] = translations[key] || '';
            } else if (translations[key]) {
                props[config[key]] = translations[key];
            }
        }
    }
    return props;
}

export function withTranslations(Component) {
    return function TranslationsComponent(props) {
        return (
            <TranslationsContext.Consumer>
                {(translations) => <Component {...props} translations={translations}/>}
            </TranslationsContext.Consumer>
        );
    };
}

/**
 * @param {object literal} config
 * @param {boolean} allowUndefined - Default: false; default props to empty string or allow them to be undefined
 */
export function withTranslationsAsProps(config, allowUndefined) {
    return function(Component) {
        return function(props) {
            return (
                <TranslationsContext.Consumer>
                    {(translations) => {
                        const translationsProps = mapTranslationsProps(config, translations, allowUndefined);
                        return <Component {...props} {...translationsProps} />;
                    }}
                </TranslationsContext.Consumer>
            );
        };
    };
}



// WEBPACK FOOTER //
// ./src/universal/components/translations/with-translations.js